export enum VerifyCodeTypes {
    registration,
    restorePassword
}